import { useCallback } from 'react';
import { KonvaEventObject } from 'konva/lib/Node';

import { useEditorContext } from '@/features/canvas/contexts/editor-context';

export const useNodeFocusOut = () => {
  const {
    filteredNodes,
    activeFilterIds,
    optionCheckedIds,
    setOptionCheckedIds,
    showDependencies,
    activeDependencyNodeIds,
    viewMode,
  } = useEditorContext();

  const onNodeFocusOut = useCallback(
    (event: KonvaEventObject<MouseEvent>) => {
      const stage = event.target.getStage();
      if (!stage) return;

      const pos = stage.getPointerPosition();
      if (!pos) return;

      const nodeIds = new Set(filteredNodes.map(n => n.id));
      const target = stage.getIntersection(pos);
      const isInsideNode =
        target?.parent?.id() !== undefined && nodeIds.has(Number(target.parent.id()));

      if (isInsideNode) return;

      // Don't clear filters when in filter mode with active filters
      if (viewMode === 'filter' && activeFilterIds.length > 0 && optionCheckedIds.length > 0) {
        return; // Just return without doing anything
      }

      // Don't clear when dependencies are active
      if (showDependencies && activeDependencyNodeIds.size > 0) {
        return;
      }

      // Don't clear when in budget mode
      if (viewMode === 'budget') {
        return;
      }

      // Only clear if we're in a state where clearing makes sense
      // (e.g., no active filters, not in dependency mode, etc.)
      if (optionCheckedIds.length > 0 && activeFilterIds.length === 0) {
        setOptionCheckedIds([]);
      }
    },
    [
      activeFilterIds,
      filteredNodes,
      optionCheckedIds,
      setOptionCheckedIds,
      showDependencies,
      activeDependencyNodeIds,
      viewMode,
    ]
  );

  return { onNodeFocusOut };
};
